import React from "react";
import {Card, CardContent, Grid} from "@material-ui/core";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const SkeletonListCard = (props: any) => {
  return (
    <>
      {Array(props?.numOfRows)
        .fill(0)
        .map((index) => (
          <Card className="list_card" variant="outlined" key={index}>
            <CardContent className="card_content">
              <div className="depot_details">
                <Grid container>
                  <Grid item xs={6}>
                    <div className="depot_information ">
                      {props?.hasMap && (
                        <div className="depot_location_map no-border">
                          <Skeleton width={70} height={70} />
                        </div>
                      )}
                      <div className="depot_info">
                        <div className="depot_name">
                          <Skeleton width={150} />
                        </div>
                        <div className="depot_addr">
                          <Skeleton width={300} />
                        </div>
                        <div className="port_details">
                          <span className="alert" style={{display: "inline-block"}}>
                            <Skeleton width={80} />
                          </span>
                          <span className="port portDetailsEVSE" style={{display: "inline-block"}}>
                            <Skeleton width={80} />
                          </span>
                        </div>
                      </div>
                    </div>
                  </Grid>
                  <Grid item md={6}>
                  {props?.hasEdit && (
                        <div className="action_icon full_right">
                          <Skeleton width={25} height={25}  />
                        </div>
                      )}
                  </Grid>
                </Grid>
                <div className="stat_list">
                  {Array(props?.numOfStatusButton)
                    .fill(0)
                    .map((index) => (
                      <span className="port mr-10" key={index} style={{display: "inline-block"}}>
                        <Skeleton width={100} height={30} />
                      </span>
                    ))}
                </div>
              </div>
            </CardContent>
          </Card>
        ))}
    </>
  );
};

export default SkeletonListCard;
